import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore as reduxCreateStore,
} from 'redux'
import thunk from 'redux-thunk'
import authentication from './reducers/authentication'
import cart from './reducers/cart'
import dynamicForm from './reducers/dynamic_form'
import environment from './reducers/environment'
import genericData from './reducers/generic_data'
import injectedComponents from './reducers/injected_components'
import infoBox from './reducers/info_box'
import session from './reducers/session'
import specialization from './reducers/specialization'

const rootReducer = combineReducers({
  authentication,
  cart,
  dynamicForm,
  environment,
  genericData,
  injectedComponents,
  infoBox,
  session,
  specialization,
})

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

const createStore = () =>
  reduxCreateStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
export default createStore
